<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
<!--  <iframe src="https://home.shockping.com/myeditor/editor/editor_new.html" :style="'width:100%;border:0;height:100%'" ref='iframeEditor'></iframe>-->
  <iframe src="https://home-editor.mocoplex.com/editor.html" :style="'width:100%;border:0;height:100%'" ref='iframeEditor'></iframe>
</template>
<script>

export default {
  data: () => ({

  }),
  mounted() {
    // this.$refs.iframeEditor.style.height = (window.innerHeight - 64) + 'px';
    //this.$refs.iframeEditor.style.height = (window.innerHeight - 223) + 'px';
    const thisObj = this;
    window.addEventListener( 'message', function(obj) {
      const data = obj.data;
      if(data.key == 'getHtmlReturn'){
        thisObj.getHtmlReturn(obj.data.html, obj.data.maxWidth);
      }else if(data.key == 'getPageInfo'){
        thisObj.getPageInfo();
      }
    });
  },
  methods: {
    getHtml: function(){
      const postMessageData = {
        key: 'getHtml'
      }
      this.$refs.iframeEditor.contentWindow.postMessage(postMessageData, '*' );
    },
    getHtmlReturn(html, maxWidth){
      this.$emit('getHtmlReturn', html, maxWidth);
    },
    getPageInfo(){
      this.$emit('getPageInfo');
    },
    setHtml(html, tempUser, domain, data){
      let searchParams = new URLSearchParams(window.location.search)
      let brandbooster = searchParams.get('brandbooster')
      const postMessageData = {
        key: 'setHtml',
        html: html,
        tempUser: tempUser,
        brandbooster: brandbooster,
        domain: domain,
        data: data,
      }
      this.$refs.iframeEditor.contentWindow.postMessage(postMessageData, '*' );
    },
    setIframe(iframeUrl){
      const postMessageData = {
        key: 'setIframe',
        iframeUrl: iframeUrl
      }
      this.$refs.iframeEditor.contentWindow.postMessage(postMessageData, '*' );
    },
  }
}
</script>